module.exports = __webpack_public_path__ + "img/icon-5.32fc9a55.svg";